import { render } from "./AccountProfile.vue?vue&type=template&id=a351df0e&scoped=true"
import script from "./AccountProfile.vue?vue&type=script&lang=js"
export * from "./AccountProfile.vue?vue&type=script&lang=js"

import "./AccountProfile.vue?vue&type=style&index=0&id=a351df0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a351df0e"]])

export default __exports__